import { Directive, ChangeDetectorRef } from '@angular/core';

import { SnDrawerAppContentDirective, SnDrawerService } from '@lib/ui/drawer';

@Directive({
  selector: '[snLayoutContent], sn-layout-content',
  host: {
    class: 'sn-layout-content',
    '[class.sn-drawer-app-content]': 'false',
  },
})
export class SnLayoutContentDirective extends SnDrawerAppContentDirective {
  constructor(drawer: SnDrawerService, changeDetectorRef: ChangeDetectorRef) {
    super(drawer, changeDetectorRef);
  }
}
